import React from 'react';
import cx from 'classnames';
//import './common.css';

const styles = {
  direction: {
    row: 'flex-row',
    column: 'flex-col',
  },
  justify: {
    start:	"justify-start",
    end:	"justify-end",
    center:	"justify-center",
  },
  align: {
    start:	"items-start",
    end:	"items-end",
    center:	"items-center",
  },
  flex: [
    'flex-00',
    'flex-01',
    'flex-02',
    'flex-03',
  ],
};

export interface FlexRowProps {
  direction?:				"row" | "column";
  justify?:					"start" | "end" | "center";
  align?:					"start" | "end" | "center";
  width?:					number | string;
  height?:					number | string;
  flex?:					number;
  children?:				React.ReactNode;
  className?:				string | (string | undefined)[];
  innerRef?:				any;
  
  onClick?:					() => any;
}

const FlexRow = (fprops: FlexRowProps) => {
  const {direction, justify, align, width, height, flex, children, className, innerRef, ...props} = fprops;
  
  const d = direction
  			?	direction
  			:	'row';
  
  const f = flex === undefined
  			?	1
  			:	flex;
  
  const w = width === undefined
  			?	'w-full'
  			:	width;
  
  const j = justify === undefined
  			?	'start'
  			:	justify;
  
  const a = align === undefined
  			?	'center'
  			:	align;
  
  //const cn = [
  //  ...(Array.isArray(className) ? className : [className]),
  //];
  
  const classes = cx(
    'flex',
    styles.direction[d],
    styles.flex[f],
    styles.justify[j],
    styles.align[a],
    { 'w-full': width === undefined  },
    height,
    className,
  );
  
  return (
  <div ref={innerRef}
       className={classes}
       {...props}>
    { children }
  </div>
  );
};



/*styled("div", {
  boxSizing: "border-box",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  flex: 1,
});*/

export default FlexRow;

